import {
  Castle, Shield, User, GitBranch, Sparkles, Feather, BookOpen, Crown, Sword, Swords, Scroll, Map, Gem, Flame, Snowflake,
  Mountain, Ship, Skull, Star, Moon, Sun, Landmark, Bird, Flower2, Users, Music, Trees, Wand2, Anchor, Hourglass,
} from "lucide-react";

export const ICONS = { Castle, Shield, User, GitBranch, Sparkles, Feather, BookOpen, Crown, Sword, Swords, Scroll, Map, Gem, Flame, Snowflake,
  Mountain, Ship, Skull, Star, Moon, Sun, Landmark, Bird, Flower2, Users, Music, Trees, Wand2, Anchor, Hourglass };

const FALLBACK = { key: "generic", label: "General Article", icon: "BookOpen", fields: [], theme: "neutral", image_shape: "landscape", layout: "normal", outline: [] };
let registry = { generic: FALLBACK };

export const setTemplateRegistry = (list) => { registry = Object.fromEntries([["generic", FALLBACK], ...(list || []).map((t) => [t.key, t])]); };
export const listTemplates = () => Object.values(registry);

export const templateOf = (key) => {
  const t = registry[key] || registry.generic;
  return { ...t, icon: ICONS[t.icon] || BookOpen };
};

export const outlineHtml = (outline) => (outline || []).map((h) => `<h2>${h.replace(/</g, "&lt;")}</h2><p></p>`).join("");

export const THEMES = [
  { value: "frost", label: "Frost" },
  { value: "flame", label: "Flame" },
  { value: "neutral", label: "Vellum (neutral)" },
];
